export default __webpack_public_path__ + "static/media/down-17.2137eacb.svg";